// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-container {
    border: 2px solid #264EC8;
    border-radius: 15px;
    padding: 20px;
    margin-bottom: 40px;
}
.job-element {
    display: flex;
    justify-content: space-between;
}
.search_bar {
    width: 100%;
    margin: 0px 20px 0px 0px;
    border: 2px solid var(--dPink);
    border-radius: 25px;
    padding: 10px;
}
.filter-btns button {
    background-color: transparent;
    background-color: initial;
    border-radius: 50px;
    border: 2px solid #977CFF;
    padding: 10px 25px;
    color: var(--uPGrey);
}
.career_newslatter {
    background: #FFF8E6;
    padding: 100px;
}
.pagination 
{
    padding: 50px 0px 20px 0px;
}
.pagination + span
{
    padding-bottom: 100px;
}
.pagination span
{
    margin-right: 20px;

}
.pagination svg
{
    color: #000;
}
.pagination span.active
{
    background: var(--dBlue);
    height: 30px;
    width: 30px;
    line-height: 30px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    font-weight: 700;
}
.career_newslatter .subscription {
    width: 40%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.career_newslatter h2
{
z-index: 2;
position: relative;
}
.career_newslatter img{
    z-index: 1;
}
p.job-info-description.pSize.fw-400
{
color:#323232
}
@media(max-width:576px)
{
    .career_newslatter {
        padding: 50px 0px;
    }
    .search_bar {
        padding: 5px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Career.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,6BAAuB;IAAvB,yBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;;IAEI,0BAA0B;AAC9B;AACA;;IAEI,qBAAqB;AACzB;AACA;;IAEI,kBAAkB;;AAEtB;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAET,gCAAgC;AACpC;AACA;;AAEA,UAAU;AACV,kBAAkB;AAClB;AACA;IACI,UAAU;AACd;AACA;;AAEA;AACA;AACA;;IAEI;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".job-container {\n    border: 2px solid #264EC8;\n    border-radius: 15px;\n    padding: 20px;\n    margin-bottom: 40px;\n}\n.job-element {\n    display: flex;\n    justify-content: space-between;\n}\n.search_bar {\n    width: 100%;\n    margin: 0px 20px 0px 0px;\n    border: 2px solid var(--dPink);\n    border-radius: 25px;\n    padding: 10px;\n}\n.filter-btns button {\n    background-color: unset;\n    border-radius: 50px;\n    border: 2px solid #977CFF;\n    padding: 10px 25px;\n    color: var(--uPGrey);\n}\n.career_newslatter {\n    background: #FFF8E6;\n    padding: 100px;\n}\n.pagination \n{\n    padding: 50px 0px 20px 0px;\n}\n.pagination + span\n{\n    padding-bottom: 100px;\n}\n.pagination span\n{\n    margin-right: 20px;\n\n}\n.pagination svg\n{\n    color: #000;\n}\n.pagination span.active\n{\n    background: var(--dBlue);\n    height: 30px;\n    width: 30px;\n    line-height: 30px;\n    border-radius: 50%;\n    color: #fff;\n    text-align: center;\n    vertical-align: middle;\n    font-weight: 700;\n}\n.career_newslatter .subscription {\n    width: 40%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n.career_newslatter h2\n{\nz-index: 2;\nposition: relative;\n}\n.career_newslatter img{\n    z-index: 1;\n}\np.job-info-description.pSize.fw-400\n{\ncolor:#323232\n}\n@media(max-width:576px)\n{\n    .career_newslatter {\n        padding: 50px 0px;\n    }\n    .search_bar {\n        padding: 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
